import React from 'react'

import { Link } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import { Spin, Alert } from 'antd'
import ajax from '../components/ControlPanel/utils/ajax'
import globalConfig from '../components/ControlPanel/config'
// import { Avatar } from '../components/Image'
import CommonPage from '../components/CommonPage'
import { Tweet } from 'react-twitter-widgets'
import { Scrollbars } from 'react-custom-scrollbars'

import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import { CircularProgress } from 'material-ui/Progress'
import Styles from '../styles/Styles'

import classNames from 'classnames'

import '../styles/NewsGrid.scss'

import TopicPage from '../components/TopicPage'

class TopicDl4Health extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { classes } = this.props
        const { match, beforeAll, beforeAllFunc } = this.props
        let { alias } = match.params
        if (alias) {
            // not home
            return (<TopicPage title="" domain="dl4health.org" alias={alias} />)
        } else {
            // home
            return (<TopicPage title="" domain="dl4health.org" alias="" />)
        }
    }
}


TopicDl4Health.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(Styles)(TopicDl4Health)
